import FullBleedHero from "./FullBleedHero"
export * from './FullBleedHero'
export default FullBleedHero
